import i18next from "@/i18n";
import type { TOptions } from "i18next";

export const NOTIFICATIONS = {
  // SUCCESS
  SUCCESS_LOGIN: { message: i18next.t("login_success") },
  SUCCESS_RESTOCK: { message: i18next.t("restock") },
  SUCCESS_NEWSLETTER_SUBSCRIBE: { message: i18next.t("newsletter_subscribe") },
  SUCCESS_LOGOUT: { message: i18next.t("logout") },
  SUCCESS_CANCEL_ORDER: { message: i18next.t("cancel_order_success") },
  SUCCESS_MODIFY_ACCOUNT_INFO: { message: i18next.t("modify_account_info") },
  SUCCESS_TOSS_VALIDATE: { message: i18next.t("validate_toss") },

  // WARNING
  WARNING_PASSWORD_NOT_MATCH: { message: i18next.t("not_match_password") },
  WARNING_PASSWORD_SAME_AS_BEFORE: { message: i18next.t("same_password") },
  WARNING_NO_LOGIN: { message: i18next.t("no_login") },
  WARNING_END_SESSION: { message: i18next.t("end_session") },
  WARNING_NO_CART: { message: i18next.t("cart.empty") },
  WARNING_NO_PRODUCT: { message: i18next.t("remove_product") },
  WARNING_OVER_PRODUCT: { message: i18next.t("over_product") },
  WARNING_NO_RETURN: { message: i18next.t("no_return_for_gift") },
  WARNING_NO_REASON: { message: i18next.t("return.select_reason") },
  WARNING_NO_DETAIL_REASON: { message: i18next.t("no_detail_reason") },
  WARNING_NO_RETURN_PRODUCTS: { message: i18next.t("account.return.select_item") },
  WARNING_NO_IMAGE: { message: i18next.t("no_image") },
  WARNING_SOCIAL_ACCOUNT: (social: TOptions) => ({ message: i18next.t("social_account", social) }),
  WARNING_SAME_ACCOUNT_INFO: { message: i18next.t("same_account_info") },
  WARNING_INVALID_SHIPPING_ADDRESS: { message: i18next.t("necessary_invalid_shipping_address") },
  WARNING_EXCEEDED_PURCHASE_LIMIT: { message: i18next.t("exceed_purchase_limit") },
  WARNING_RESTOCK: { message: i18next.t("already_restock") },
  WARNING_NO_QUANTITY: { message: i18next.t("cart.empty") },

  // ERROR
  ERROR_SERVER: { message: i18next.t("server") },
  ERROR_SEARCH: { message: i18next.t("search.alert") },
  ERROR_CHECKOUT: { message: i18next.t("checkout_failed") },
  ERROR_SELECT_OPTION: { message: i18next.t("select_option") },
  ERROR_DISCOUNT_CODE: { message: i18next.t("checkout.wrong_discount_name") },
  ERROR_CANCEL_ORDER: { message: i18next.t("cancel_order_failed") },
  ERROR_NO_RETURN_PRODUCT: { message: i18next.t("failed_no_return_product") },
  ERROR_EXCEED_QTY: { message: i18next.t("quantity_limit") },
};
